const INITIAL_VISIBLE = 80

export const getCurrentTranslation = (elementHeight, yDiff) => {
  const isSwipeUp = yDiff < 0
  const absDiff = Math.abs(yDiff)
  const bounding = elementHeight - INITIAL_VISIBLE

  if (isSwipeUp) {
    return absDiff < bounding ? bounding - absDiff : 0
  } else {
    return absDiff < bounding ? absDiff : bounding
  }
}
